// extracted by mini-css-extract-plugin
module.exports = {"common-description":"J0f3n2","common-icon-arrow-animated-base":"_7t3Hvw","common-icon-arrow-animated-head":"LoICDk","common-icon-arrow-animated-active":"dQvycZ","base":"_5OmojA"};